import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import StatusMessage from "../../components/statusMessage/StatusMessage";
import DataTable from "../../components/dataTables/DataTable";
import { useLogs } from "../../hooks";
import { useEffect } from "react";

export function Logs() {
  const { logs } = useLogs("");

  useEffect(() => {
    console.log(logs);
  }, [logs]);

  return (
    <LeftSideMenu active="logs">
      <StatusMessage />
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">
                  ALIMENTOS
                </h4>
                <ul className="nav nav-pills">
                  <li className="active">
                    <a
                      href="#tabViewLogs"
                      data-toggle="tab"
                      aria-expanded="true"
                    >
                      <i className="fas fa-plus-circle"></i> LISTAR LOGS
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div id="tabViewLogs" className="tab-pane fade">
                    {/*<DataTable colDefs={colDefs} data={logs} dataId={"Logs"} resizable={true}
                                               allowHiddenColumns={true} scrollX={false}
                                               className="table table-bordered panel-group"/>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
